import * as React from 'react';
// mui
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography
} from '@mui/material';
// icons
import CheckIcon from '@mui/icons-material/Check';
// redux
import { useDispatch, useSelector } from 'react-redux';
// axios
import api from '../../axios';
import { selectTimezone } from '../../store/selectors/authSelectors';
import { setTimezone } from '../../store/slices/authSlice';

const timezones: string[] = Intl.supportedValuesOf("timeZone");

export default function SettingsPage() {
  const dispatch = useDispatch();

  const userTimezone: string | null = useSelector(selectTimezone());

  const [ snackbarMessage, setSnackbarMessage ] = React.useState<string | null>(null);

  const [ localTimezone, setLocalTimezone ] = React.useState<string>(userTimezone || '');
  const [ timezoneLoading, setTimezoneLoading ] = React.useState<boolean>(false);

  const [ email, setEmail ] = React.useState('');
  const [ resetPasswordLoading, setResetPasswordLoading ] = React.useState<boolean>(false);

  const updateTimezone = () => {
    setTimezoneLoading(true);
    api
      .post('/users/settimezone', { timezone: localTimezone })
      .then((res) => {
        console.log(res);
        if (res.data === 'OK') {
          dispatch(setTimezone(localTimezone));
          setSnackbarMessage('Timezone Updated!');
        }
      })
      .catch(console.error)
      .finally(() => {
        setTimezoneLoading(false);
      });
  }

  const resetPassword = () => {
    setResetPasswordLoading(true);
    api
      .post('/users/resetpw', { email })
      .then((res) => {
        console.log(res);
        setSnackbarMessage('Email With Reset Password Instructions Sent!');
      })
      .catch(console.error)
      .finally(() => {
        setResetPasswordLoading(false);
      });
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      minHeight="calc(100vh - 112px)"
    >
      <Card sx={{ width: '100%', m: 0, p: 2 }} variant="outlined">
        <CardHeader 
          title="Settings"
        />
        <Divider />
        <CardContent>
          <Typography variant="subtitle1">Reset Password</Typography>
          <Grid sx={{ width: '100%' }} container spacing={2}>
            <Grid size={8}>
              <TextField
                label="Email"
                variant="standard"
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); }}
                fullWidth
                sx={{ paddingBottom: 2 }}
              />
            </Grid>
            <Grid size={4}>
              <Button
                fullWidth
                sx={{ mt: 1 }}
                loading={resetPasswordLoading}
                variant="outlined"
                onClick={resetPassword}
              >
                Reset
              </Button>
            </Grid>
          </Grid>

          <Typography variant="subtitle1">Timezone</Typography>
          <Grid sx={{ width: '100%' }} container spacing={2}>
            <Grid size={8}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={localTimezone}
                label="Timezone"
                variant="standard"
                sx={{ p: 1 }}
                fullWidth
                onChange={(e) => { setLocalTimezone(e.target.value); }}
              >
                { timezones.map((currentTimezone, i) => (
                  <MenuItem key={i} value={currentTimezone}>{currentTimezone}</MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid size={4}>
              <Button
                fullWidth
                sx={{ mt: 1 }}
                loading={timezoneLoading}
                onClick={updateTimezone}
                variant="outlined"
              >
                Update
              </Button>
            </Grid>
          </Grid>

          <Typography sx={{ mt: 2, mb: 1 }} variant="subtitle1">Subscription</Typography>
          <Card variant="outlined">
            <CardHeader
              avatar={<CheckIcon color="primary" />}
              title="Alpha Tester Subscription"
              subheader="$0/Month"
              action={<Button sx={{ m: 1 }} variant="outlined" disabled>End Subscription</Button>}
            />
          </Card>
        </CardContent>
      </Card>

      <Snackbar
        open={!!snackbarMessage}
        autoHideDuration={6000}
        onClose={() => { setSnackbarMessage(null); }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
